import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import { Autocomplete, Box, Button, Stack, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import {
  assignBatchToCro,
  assignBatchtoSme,
  changeBatchStatus,
  getBatchesList,
  getCROList,
  getSmeList,
  getSmoSmeLeads,
  getTutorsList,
} from "../../redux/features/batchSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import * as Yup from "yup";

const AssignSme = ({ rowData, dispatchData, open, setOpen }) => {
  // const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, smeList } = useSelector((state) => state.batch);

  const validationSchema = Yup.object().shape({
    sme_id: Yup.string().required("Choose a SME"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sme_id: rowData?.sme_assigned || "",
      batchID: rowData?.course_batch_id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(assignBatchtoSme(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getSmoSmeLeads(dispatchData));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getSmeList());
    }
  }, [open]);

  return (
    <GlobalDialog
      title={"Assign SME"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <Autocomplete
                    name="sme_id"
                    fullWidth
                    options={smeList}
                    getOptionLabel={(option) => option.name || ""}
                    onChange={(event, newValue) => {
                      formik.setFieldValue("sme_id", newValue?.userID || "");
                    }}
                    value={
                      smeList.find(
                        (sme) => sme.userID === formik.values.sme_id
                      ) || null
                    }
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="SME"
                        placeholder="Select SME"
                        error={
                          formik.touched.sme_id && Boolean(formik.errors.sme_id)
                        }
                        helperText={
                          formik.touched.sme_id && formik.errors.sme_id
                        }
                      />
                    )}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={loading}
                      variant="contained"
                      color="secondary"
                      size="small"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Assign"}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AssignSme;
